import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import SketchfabSingleModel from '../../common/SketchfabSingleModel'

const GameModeling = () => {
  return (
    <>
        <Card className='no-border rounded-0 game-modeling container'>
            <Card className='no-border rounded-0' >
                <Card className='text-center no-border rounded-0 game-modeling-top-section'>
                    <Card.Body className='game-modeling-chinese-fort-top pb-md-5 container'>
                        <Card.Title className='game-modeling-title'> ゲームモデリング </Card.Title>
                        <Card.Text className='game-modeling-top-text text-left'>
                        Unity や Unreal Engine などの 3D ゲーム エンジンでは、ポリゴン数やパフォーマンス要件、リアルタイム レンダリング、ベイクドライティング技術など、3D モデリングに対する独自の要件があります。実写のリファレンス画像に基づいてモデリングする場合でも、クリエイティブなファンタジーのデザインであっても、当社のアーティストは高品質の3Dゲームアセットを作成するエキスパートです。
                        </Card.Text>
                    </Card.Body>
                    <Card.Img src={"/assets/game/images/chinese_gate.jpg"} alt="Chinese Fort" />
                    <Card.ImgOverlay className='chinese-fort-card-image-overlay'>
                        <Card.Subtitle className="game-modeling-subtitle py-md-4"> 中国の城門 </Card.Subtitle>
                        <Card.Text className='game-modeling-text text-left'>
                        Unreal Engineで撮影されたバーチャルプロダクションの映像のために制作しました。
                        </Card.Text>
                    </Card.ImgOverlay>
                </Card>

                <Card className='no-border rounded-0 text-center'>
                    <Card.Body className='game-modelling-3d-assets-body'>
                        <Card.Title className='game-modeling-3d-assets py-md-5'>3Dゲームアセット</Card.Title>
                        <Row>
                            <Col md={2}></Col>
                            <Col md={8}>
                                <div className="scorpio-modeling-section">
                                    <SketchfabSingleModel  modelId="e92de698b2ee433ab4675dfbf35ed1e2" />
                                </div>
                            </Col>
                            <Col md={2}></Col>
                        </Row>
                    </Card.Body>
                </Card>
                    <Row  xs={5} md={5}  className=''>
                        
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_001.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_002.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_003.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_004.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_005.png"} alt="" />
                            </Card>
                        </Col>
                        
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_006.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_007.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_008.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_009.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={"/assets/game/images/game_010.png"} alt="" />
                            </Card>
                        </Col>
                        
                    </Row>
            </Card>
        </Card>
    </>
  )
}

export default GameModeling
